import React from 'react';
import { InputList, useInputHelper } from 'framework/form';
import {
  ExternalResource,
  getProjectLinkConfigByName,
  PROJECT_LINK_CONFIG,
  restrictedResourcesForPartialManage,
} from 'domain/shared/newProject';
import ProjectToolInput from './ProjectToolInput';

interface ExternalResourcesListProps {
  source: string;
  disabled: boolean;
  hasFullManageAccess?: boolean;
}

const ExternalResourcesList = ({ source, disabled, hasFullManageAccess = true }: ExternalResourcesListProps) => {
  const { getValue } = useInputHelper({ source });
  const usedTools = (getValue() || []).map((v: ExternalResource) => v.name);
  const availableLinkTypes = PROJECT_LINK_CONFIG.filter(
    ({ name, isMultiple }) => isMultiple || !usedTools.includes(name),
  );

  const getDisabledState = (data: ExternalResource) => {
    if (disabled) {
      return !getProjectLinkConfigByName(data.name).isMultiple;
    }
    return !hasFullManageAccess && restrictedResourcesForPartialManage.includes(data.name);
  };

  return (
    <InputList
      source={source}
      disabledRemove={getDisabledState}
      addText="Add tool"
      inputTemplate={ProjectToolInput}
      inputProps={{
        suggestions: availableLinkTypes,
        disabled: getDisabledState,
        hasFullManageAccess,
      }}
      defaultValue={{ name: '', value: '' }}
      maxFields={1000}
    />
  );
};

export default ExternalResourcesList;
